<template>
  <v-container fluid class="features">
    This is Features page.
  </v-container>
</template>

<script>
export default {
  name: "FeaturesComponent",
  components: {},
  data: () => ({})
};
</script>
<style scoped lang="scss" src="./Features.scss"></style>
